







import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AMXFormField',
  props: {
    validationError: {
      type: String,
      default: null,
    },
  },
});
